function clamp(n, min = 0, max = 100) {
  return Math.max(min, Math.min(max, n));
}

function hexToHsl(hex) {
  let c = hex.replace('#', '');
  if (c?.length === 3)
    c = c
      .split('')
      .map(x => x + x)
      .join('');
  const r = parseInt(c.slice(0, 2), 16) / 255;
  const g = parseInt(c.slice(2, 4), 16) / 255;
  const b = parseInt(c.slice(4, 6), 16) / 255;
  const max = Math.max(r, g, b),
    min = Math.min(r, g, b);
  let h = 0,
    s = 0,
    l = (max + min) / 2;
  if (max !== min) {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r:
        h = (g - b) / d + (g < b ? 6 : 0);
        break;
      case g:
        h = (b - r) / d + 2;
        break;
      case b:
        h = (r - g) / d + 4;
        break;
      default:
        return;
    }
    h = h * 60;
  }
  return { h: Math.round(h), s: Math.round(s * 100), l: Math.round(l * 100) };
}

function hslToString(h, s, l) {
  return `hsl(${Math.round(h)}, ${Math.round(s)}%, ${Math.round(l)}%)`;
}

// accept hex or hsl(...) and allow hsl to pass through
function deriveShades(base, { hoverDelta = -10, lightDelta = +40 } = {}) {
  let hsl;
  if (base.trim().startsWith('hsl')) {
    return { base, hover: base, light: base };
  } else {
    hsl = hexToHsl(base);
  }
  const hover = hslToString(hsl.h, hsl.s, clamp(hsl.l + hoverDelta));
  const light = hslToString(
    hsl.h,
    Math.round(hsl.s * 0.6),
    clamp(hsl.l + lightDelta)
  );
  const baseStr = hslToString(hsl.h, hsl.s, hsl.l);
  return { base: baseStr, hover, light };
}

function readableTextOn(bgHsl) {
  const m = /hsl\(\s*[\d.]+,\s*[\d.]+%,\s*([\d.]+)%\s*\)/.exec(bgHsl);
  const l = m ? parseFloat(m[1]) : 50;
  return l > 60 ? 'black' : 'white';
}

export function applyWhiteLabelTheme(theme, scope) {
  if (typeof document === 'undefined') return;
  const candidate =
    scope && scope.nodeType === 9
      ? scope.documentElement
      : scope && scope.nodeType === 1
        ? scope
        : document.documentElement;
  const root = candidate;

  const { primary, secondary, danger } = theme || {};
  if (!primary || !secondary || !danger) return;
  if (![primary, secondary, danger].every(Boolean)) return;

  // will need to add fontFamily bad in above
  //   if (fontFamily) root.style.setProperty('--font-family', fontFamily);
  const prim = deriveShades(primary);
  const sec = deriveShades(secondary);
  const dang = deriveShades(danger);

  root.style.setProperty('--color-green', prim.base);
  root.style.setProperty('--color-green-hover', prim.hover);
  root.style.setProperty('--color-green-light', prim.light);

  root.style.setProperty('--color-blue', sec.base);
  root.style.setProperty('--color-blue-hover', sec.hover);
  root.style.setProperty('--color-blue-light', sec.light);

  root.style.setProperty('--color-red', dang.base);
  root.style.setProperty('--color-red-hover', dang.hover);
  root.style.setProperty('--color-red-light', dang.light);

  root.style.setProperty('--text-on-green', readableTextOn(prim.base));
  root.style.setProperty('--text-on-blue', readableTextOn(sec.base));
  root.style.setProperty('--text-on-red', readableTextOn(dang.base));
}
